<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
      </b-container>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md" class="d-flex">
                      <b-list-group-item class="b-group-item-end" variant="secondary">
                        <div>
                          <span class="small-description">адрес погрузки</span>
                          {{ editedData.naselenniy_punkt || '<Здесь будет населенный пункт>' }}
                        </div>
                        <!-- <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['vihod_sudna_iz_porta_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['vihod_sudna_iz_porta_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div> -->
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['vihod_sudna_iz_porta_plan'], editedData['vihod_sudna_iz_porta_fact'])">
                        <div>
                          <span class="small-description">порт отгрузки</span>
                          {{ editedData.port_of_shipment || '<Здесь будет порт отгрузки>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['vihod_sudna_iz_porta_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['vihod_sudna_iz_porta_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['pribitie_sudna_v_port_plan'], editedData['pribitie_sudna_v_port_fact'])">
                        <div>
                          <span class="small-description">порт прибытия</span>
                          {{ editedData.port_of_unloading || '<Здесь будет порт прибытия>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['pribitie_sudna_v_port_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['pribitie_sudna_v_port_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <template v-if="editedData['station_of_incoming_id'] != 888">
                        <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['raskreditaciya_plan'], editedData['raskreditaciya_fact'])">
                          <div>
                            <span class="small-description">станция прибытия</span>
                            {{ nameByPropId(editedData.station_of_incoming_id) || '<Здесь будет станция прибытия>' }}
                          </div>
                          <div class="mt-2">
                            <div><small><b>План:</b> {{ editedData['raskreditaciya_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                            <div><small><b>Факт:</b> {{ editedData['raskreditaciya_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          </div>
                        </b-list-group-item>
                      </template>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])">
                        <div>
                          <span class="small-description">адрес разгрузки</span>
                          {{ editedData.address_of_unloading || '<Здесь будет адрес разгрузки>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['dostavka_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['dostavka_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>

    </b-overlay>
  </div>
</template>

<script>
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'etapy',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {},
  computed: {
    transitnoe_vremya() {
      if (!this.editedData['pribitie_sudna_v_port_fact'] || !this.editedData['vihod_sudna_iz_porta_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['vihod_sudna_iz_porta_fact'], this.editedData['pribitie_sudna_v_port_fact']);
      return transitnoe_vremya;      
    },
    time_of_to() {
      if (!this.editedData['vypusk_dt_fact'] || !this.editedData['podacha_dt_fact']) {
        // return 'Заполните поля <Выпуск ДТ> и <Подача ДТ>';
        return "<Расчет недоступен>";
      } 

      const time_of_to = this.getDiffNumberOfDays(this.editedData['podacha_dt_fact'], this.editedData['vypusk_dt_fact']);
      return time_of_to;
    },
    transitnoe_vremya_gd() {
      if (!this.editedData['raskreditaciya_fact'] || !this.editedData['vyhod_po_gd_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['vyhod_po_gd_fact'], this.editedData['raskreditaciya_fact']);
      return transitnoe_vremya;      
    },
    transitnoe_vremya_gd_bez_gd() {
      if (!this.editedData['raskreditaciya_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['raskreditaciya_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    },
    obshee_transitnoe_vremya() {
      if (!this.editedData['zatarka_containera_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['zatarka_containera_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    }
  },
  watch: {
    transitnoe_vremya(value) {
      this.editedData['transitnoe_vremya'] = value;
    },
    time_of_to(value) {
      this.editedData['time_of_to'] = value;
    },
    obshee_transitnoe_vremya(value) {
      this.editedData['obshee_transitnoe_vremya'] = value;
    }
  },
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'etapy',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        usloviya_postavki_id: null,
        naselenniy_punkt: '',

        cargo_recipient_name: '',
        address_g_p: '',
        address_of_unloading: '',
        contact_name_on_unloading: '',
        notify_contacts: '',
        agent_contacts: '',

        perevozchik_id: null,
        perevozchik_name: '',
        perevozchik_inn: '',
        perevozchik_uridicheskiy_address: '',

        port_of_shipment: '',
        port_of_unloading: '',
        station_of_incoming_id: null,

        number_of_container: 1, // Меняется при добавлении / удалении контейнера

        containers: [
          {
            number_of_places: 0,
            weight: 0,
            volume: 0,
            type_of_container_id: null,
            shipping_line: '',
            nomer_of_container: '',
            name_of_ship: '',
            country_of_ship_registration_id: null,
            konosaments: [
              {
                number_of_konosament: '',
                date_of_konosament_exit: '',
                sales_name: '',
                cargo_sender_name: '',
                address_g_o: '',
                contact_name_on_shipment: '',
              }
            ],
          }
        ],

        gotovnost_gruza_plan: '',
        gotovnost_gruza_fact: '',
        zatarka_containera_plan: '',
        zatarka_containera_fact: '',
        vihod_sudna_iz_porta_plan: '',
        vihod_sudna_iz_porta_fact: '',
        pribitie_sudna_v_port_plan: '',
        pribitie_sudna_v_port_fact: '', 
        poluchenie_konosamenta_fact: '',
        podacha_dt_fact: '',
        vypusk_dt_fact: '',
        transitnoe_vremya: '',
        time_of_to: '',
        vyhod_po_gd_plan: '',
        vyhod_po_gd_fact: '',
        pribitie_na_stanciyu_plan: '',
        pribitie_na_stanciyu_fact: '',
        raskreditaciya_plan: '', 
        raskreditaciya_fact: '', 
        dostavka_plan: '',
        dostavka_fact: '',
        transitnoe_vremya_gd: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        // this.editedData = Object.assign(this.editedData, JSON.parse(JSON.stringify(data.data)));
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    this.visible = this.defaultVisible;
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      let indexArray = index.split('.');
      if (indexArray.length > 1) {
        if (indexArray[0] == 'containers') {
          if (indexArray[2] != 'konosamets') {
            this.editedData[indexArray[0]][indexArray[1]][indexArray[2]] = value;  
          }
        }
      } else {
        this.editedData[index] = value;
      }
    }, 
    setCompanyPerevozchikOfOrder(value, element) {
      this.editedData['perevozchik_id'] = value;
      this.editedData['perevozchik_name'] = element.name;
      this.editedData['perevozchik_inn'] = element.inn;
      this.editedData['perevozchik_uridicheskiy_address'] = element.address;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },  
    addContainer() {
      let prevContainer = this.editedData['containers'][this.editedData['containers'].length - 1];
      this.editedData['containers'].push(JSON.parse(JSON.stringify(prevContainer)));
      this.editedData['number_of_container']++;
    },
    deleteContainer(container_index) {
      this.editedData['containers'].splice(container_index, 1);
      this.editedData['number_of_container']--;
    },
    addKonosament(container_index) {
      let prevKonosament = this.editedData['containers'][container_index]['konosaments'][this.editedData['containers'][container_index]['konosaments'].length - 1];
      this.editedData['containers'][container_index]['konosaments'].push(JSON.parse(JSON.stringify(prevKonosament)));
    },
    deleteKonosament(container_index, konosament_index) {
      this.editedData['containers'][container_index]['konosaments'].splice(konosament_index, 1);
    },
  }
};
</script>
<style scoped>
.one-container {
  background: #f2f2f2;
  border: 1px dashed #0d6247;
}

.one-konosament {
  border-left: 1px solid #CCC;
}
.one-konosament:hover {
  border-left: 1px solid #0d6247;
}
.delete-one-konosament {
  position: absolute;
  width: 80px;
  height: 30px;
  top: 40px;
  left: -60px;
  transform: rotate(-90deg);
}

.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}
.b-group-item-end {
  display: flex !important;
  justify-content: space-between !important;
}

.b-group-item-end b {
  text-transform: none;
}
</style>